import { useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";

import { ScrollablePane, Stack, useTheme } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { SoftwarePackage } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { useSoftwarePackages } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { SoftwarePackageVersionsPage } from "./software-package-versions/SoftwarePackageVersionsPage";
import { SoftwareSearchTable } from "./SoftwareSearchTable";
import {
  SoftwareSearchTableFilter,
  SoftwareSearchTableFilterValues
} from "./SoftwareSearchTableFilter";

interface SoftwarePackagesHostProps {}

const SoftwarePackagesList = () => {
  const theme = useTheme();
  const [filtersArgs, setFilterArgs] = useState<
    SoftwareSearchTableFilterValues
  >({
    name: ""
  });

  const { data: softwarePackagesData } = useSoftwarePackages();
  const navigate = useNavigate();

  const handleOpenVersions = (id: string) => {
    navigate(id);
  };

  return (
    <Stack
      verticalFill
      styles={{
        root: { padding: theme.spacing.s1, width: "100%" }
      }}
      tokens={{ childrenGap: theme.spacing.m }}
    >
      <SectionTitle>Software Packages</SectionTitle>

      <SoftwareSearchTableFilter setFilterArgs={setFilterArgs} />
      <ScrollablePane
        styles={{ root: { height: "90%", position: "relative" } }}
      >
        <SoftwareSearchTable
          items={filterAndSortRolloutSoftwarePackages(
            softwarePackagesData || [],
            filtersArgs
          )}
          onOpenVersions={handleOpenVersions}
        />
      </ScrollablePane>
    </Stack>
  );
};

export const SoftwarePackagesScreen: React.FC<SoftwarePackagesHostProps> = ({}) => {
  return (
    <Routes>
      <Route
        path=":softwarePackageId"
        element={<SoftwarePackageVersionsPage />}
      />
      <Route path="*" element={<SoftwarePackagesList />} />
    </Routes>
  );
};

const filterAndSortRolloutSoftwarePackages = (
  rolloutSoftwarePackageVersions: SoftwarePackage[],
  filter: SoftwareSearchTableFilterValues
): SoftwarePackage[] => {
  return rolloutSoftwarePackageVersions
    .filter(
      d =>
        filter.name === "" ||
        d.displayName.toLowerCase().indexOf(filter.name.toLowerCase()) >= 0
    )
    .sort((a: SoftwarePackage, b: SoftwarePackage) => {
      return a.displayName < b.displayName ? 1 : -1;
    });
};
